
// Scroll-in animations WITHOUT ever blanking content.
// Old behaviour: CSS hid every section (opacity: 0) and this script revealed them ->
// on slow devices sections stayed blank for seconds until JS ran.
// New behaviour: sections start visible. This script hides ONLY the sections that are
// below the initial viewport (adds .anim-prepared) and reveals them as they scroll in.
// If JS never runs or fails, nothing is ever hidden.
(function () {
  var allSections = document.querySelectorAll('.shopify-section');
  var mainSections = document.querySelectorAll('main > .shopify-section');

  if (!('IntersectionObserver' in window)) {
    allSections.forEach(function (el) {
      el.classList.add('section-anim-in');
      el.classList.add('section-in-view');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('section-anim-in');
        entry.target.classList.add('section-in-view');
        entry.target.dispatchEvent(new CustomEvent('section:in-viewport'));
      } else {
        entry.target.classList.remove('section-in-view');
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px 30% 0px',
    threshold: 0,
  });

  try {
    var designMode = window.Shopify && Shopify.designMode === true;
    if (!designMode) {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      mainSections.forEach(function (el, index) {
        if (index === 0) return;
        if (el.getBoundingClientRect().top > vh * 0.85) {
          el.classList.add('anim-prepared');
        }
      });
    }
  } catch (e) {
    document.querySelectorAll('.anim-prepared').forEach(function (el) {
      el.classList.remove('anim-prepared');
    });
  }

  allSections.forEach(function (el) {
    observer.observe(el);
  });
})();